import { render, staticRenderFns } from "./Test2List.vue?vue&type=template&id=0b37f217&"
import script from "./Test2List.vue?vue&type=script&lang=js&"
export * from "./Test2List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports